export default __webpack_public_path__ + "static/B0082-15c7d0a97b9bfdc8a167ea39e4b9b649.png";